import { useQuery } from '@tanstack/react-query';

import { getIssueCreateMeta } from '~/controllers/issueCreateMeta';
import { mapConfig } from '~/controllers/mapping/config';
import { IJiraConfig } from '~/domain/IJiraConfig';

import { useJiraProjectConfig } from '../useJiraProjectConfig/useJiraProjectConfig';

const defaultJiraConfig: IJiraConfig = {
  issueTypeId: '',
  fields: {},
}

export const useJiraConfigQuery = () => {
  const { data: jiraProjectConfig } = useJiraProjectConfig();

  return useQuery(
    ['jiraIssueCreateMeta'], getIssueCreateMeta,
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!jiraProjectConfig,
      select: (jiraCreateMeta) => mapConfig(jiraCreateMeta, jiraProjectConfig),
    });
}

export const useJiraConfig = () => useJiraConfigQuery().data || defaultJiraConfig;
